export default "__VITE_ASSET__f7c54eca__"